
// FINAL DECISIONS
export const GET_FINAL_DECISIONS = "/final-decisions";
